export default "__VITE_ASSET__23d253f1__"